export default __webpack_public_path__ + "static/media/sc15.4e9cc078.mp4";